import withHtmlSafe from '../withHtmlSafe';
import Heading from './Heading';
export default withHtmlSafe(Heading);